import { useQuery } from '@tanstack/react-query'

import { listVendorModels, listVendors } from './api/api'
import { vendorModelsKey, vendorsAllKey } from './keyFactory'

export function useVendors() {
  return useQuery({
    queryKey: vendorsAllKey(),
    queryFn: listVendors,
  })
}

// Disabled until a vendor is picked — the model list is vendor-scoped.
export function useVendorModels(vendorId: string) {
  return useQuery({
    queryKey: vendorModelsKey(vendorId),
    queryFn: () => listVendorModels(vendorId),
    enabled: !!vendorId,
  })
}
